var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "half_drop_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "half_drop_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L13.66,5.65 C15.22,7.21 16,9.29 16,11.29 C16,13.29 15.22,15.4 13.66,16.96 C12.1,18.52 10.05,19.31 8,19.31 C5.95,19.31 3.9,18.52 2.34,16.96 C0.78,15.4 0,13.29 0,11.29 C0,9.29 0.78,7.21 2.34,5.65 L8,0 Z M8,2.92 L3.76,7.25 C2.62,8.38 2.01,9.65 2,11.65 L14,11.65 C13.99,9.65 13.38,8.42 12.24,7.3 L8,2.92 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-232.0 -1311.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#half_drop_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.0 1309.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0 2.3499999999999996)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#half_drop_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16,0 16,19.31 0,19.31 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfDrop);
export default __webpack_public_path__ + "static/media/half-drop.8e880cb3082a07567845c002aa9fed81.svg";
export { ForwardRef as ReactComponent };